import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { LocalStorageService } from './local-storage.service';

@Injectable({ providedIn: 'root' })
export class SearchService {
  constructor(private localStorageService: LocalStorageService) {}
  private visibilityChanges = new BehaviorSubject<boolean>(false);
  public locationSubject = new Subject<string>();
  public initText = new BehaviorSubject<string>('');

  public setVisibility(visibility: boolean) {
    this.visibilityChanges.next(visibility);
  }

  public getVisibility(): boolean {
    return this.visibilityChanges.value;
  }

  public visibilityObservable(): Observable<boolean> {
    return this.visibilityChanges.asObservable();
  }

  public emitLocationChangeEvent(text: string) {
    console.log('emitLocationChangeEvent', text);
    text = text.trim();
    if (text && text != 'null') {
      this.localStorageService.setLocation(text);
      this.locationSubject.next(text);
    }
  }

  public setInitText(text: string) {
    if (text && text != 'null') this.initText.next(text);
  }
}
